import React, {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {onClient} from '@salesforce/commerce-sdk-react/utils'
import {CookieStorage} from '@salesforce/commerce-sdk-react/auth/storage'

const RiskifiedScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {riskified} = commerceAPI
    const {config} = riskified || {}

    var enabled = false
    var scriptURL = null
    var storeDomain = null

    const cookie =
        onClient() &&
        new CookieStorage({
            keySuffix: '',
            sharedContext: !onClient()
        })

    try {
        const jsonConfig = JSON.parse(config)
        enabled = jsonConfig.enabled
        scriptURL = jsonConfig.scriptURL
        storeDomain = jsonConfig.merchantDomainAddressOnRiskified
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        const dwSessionId = cookie.get('dwsid')
        if (enabled && scriptURL && storeDomain && dwSessionId) {
            const script = document.createElement('script')
            script.src = scriptURL + '?shop=' + storeDomain + '&sid=' + dwSessionId
            script.type = 'text/javascript'
            script.async = true
            script.defer = true
            document.body.appendChild(script)

            return () => {
                document.body.removeChild(script)
            }
        }
    }, [enabled, scriptURL, storeDomain, cookie])

    return <></>
}

export default RiskifiedScript
